export const HAKLAI_DATE_PICKER_ERRORS = Object.freeze({
  invalidDate: "התאריך אינו תקין"
});
